const hexRegExp = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export default angular
  .module('doxy.common.directives.dValidateHex', [])
  .directive('dValidateHex', function () {
    return {
      restrict: 'A',
      scope: false,
      require: 'ngModel',
      link: function (scope, el, attrs, ngModelCtrl) {
        ngModelCtrl.$validators[attrs.ngModel] = function (modelVal, viewVal) {
          let val = modelVal || viewVal;

          if (val) {
            let hash = val.indexOf('#');
            if (hash === -1) {
              el.val('#' + val);
            } else if (hash === 0 && (val.length === 1 || val.length === 0)) {
              ngModelCtrl.$setViewValue(null);
            }
            return hexRegExp.test(el.val());
          } else {
            return true;
          }
        };
      },
    };
  }).name;
